// extracted by mini-css-extract-plugin
export default {"root":"ItemStatus_root__vhvju","todo":"ItemStatus_todo__FCrlI","done":"ItemStatus_done__zFe48"};